import {createSelector} from 'reselect';

// Invoices redux state
const invoicesReducerSelector = state => state.invoices;

// Invoices List
const invoicesSelector = createSelector(
    invoicesReducerSelector,
    invoicesReducer => invoicesReducer.get('payload')
);

// Invoices is fetching
const invoicesIsFetchingSelector = createSelector(
    invoicesReducerSelector,
    invoicesReducer => invoicesReducer.get('isFetching')
);

// Invoices error
const invoicesErrorSelector = createSelector(
    invoicesReducerSelector,
    invoicesReducer => invoicesReducer.get('error')
);

export {
    invoicesSelector,
    invoicesIsFetchingSelector,
    invoicesErrorSelector
};